export const TRAY_PORTAL_RIGHT = 'tray-portal-right';
export const TRAY_PORTAL_LEFT = 'tray-portal-left';
export const TOOLTIP_PORTAL = 'tooltip-portal';
